module.exports = __webpack_public_path__ + "img/banner.e1683867.png";